import React,{useState,useEffect} from 'react'
import Box from '@mui/material/Box';
import {Typography,Button,Grid,} from '@mui/material';
import {makeStyles} from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import GitHubIcon from '@mui/icons-material/GitHub';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
const useStyles = makeStyles((theme)=>({
   
    card:{
         width:'300px',
         height:'300px' ,
         padding:'2rem',
         transitionProperty:"all",
         transitionDuration:"0.25s",
         transitionTimingFunction:"cubic-bezier(0.215,0.61,0.355,1)",
         '&:hover':{
            cursor:'pointer',
            transform:'translate3d(5px,-5px,5px)'
         }
        },
        githubIcon:{
            '&:hover':{
                color:'#64ffda'
            }
        },
       linkIcon:{
            '&:hover':{
                color:'#64ffda'
            }
        },
        projectDesc:{color:'#a8b2d1',
            
        },projectTitle:{
            color:'#ccd6f6',
            '&:hover':{
                color:'#64ffda'
            }
        },
        cardLink:{
            "&:visited":{
                color:'inherit'
            },
            "&:active":{
                color:'inherit'
            },
            "&:hover":{
                color:'inherit'
            }
        },
        gitLink:{
            "&:visited":{
                color:'inherit'
            },
            "&:active":{
                color:'inherit'
            },
            "&:hover":{
                color:'inherit'
            }
        },
        openLink:{
            "&:visited":{
                color:'inherit'
            },
            "&:active":{
                color:'inherit'
            },
            "&:hover":{
                color:'inherit'
            }
        }
        
    
}))



const Project = ({projectTitle,projectDesc,projectTech,gitHubLink,demoLink,demoAvailable}) => {
    const classes = useStyles()
    return (
        <div>
            <Card className={classes.card} style={{backgroundColor:'#112240',boxShadow:"0px 10px 30px -15px #020c1bb3",}} >
                        <a className={classes.cardLink} target="_blank" href={gitHubLink} style={{textDecoration:'none'}} >
                        <CardActions>
                            <IconButton className={classes.folderIcon} style={{width:'75px',height:'75px',color:'#64ffda'}}><FolderOpenIcon style={{width:'100%',height:'100%',fontWeight:'200'}}/></IconButton>
                            <Box className={classes.gitAndLinkContainer} style={{display:'flex',alignSelf:'center',width:'270px',alignItems:'flex-end',justifyContent:'flex-end'}}>
                                <a className={classes.gitLink} target="_blank" href={gitHubLink} style={{textDecoration:'none'}}>
                                    <IconButton className={classes.gitHubButton} style={{width:'40px',height:'40px',color:'#a8b2d1'}}><GitHubIcon className={classes.githubIcon} style={{width:'100%',height:'100%'}}/></IconButton>
                                </a>
                                {demoAvailable?<a className={classes.openLink} target="_blank" href={demoLink} style={{textDecoration:'none'}}>
                                    <IconButton  className={classes.linkButton} style={{width:'40px',height:'40px',color:'#a8b2d1'}}><OpenInNewIcon className={classes.linkIcon} style={{width:'100%',height:'100%'}}/></IconButton>
                                </a>:null}
                                
                                
                                
                            </Box>
                        </CardActions>
      
                        <CardContent>
                            <Typography className={classes.projectTitle} style={{fontWeight:'600',fontSize:'20px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>
                                {projectTitle}
                            </Typography>
                            
                            <Typography className={classes.projectDesc} style={{marginTop:'5px',fontSize:'16px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>
                                {projectDesc}
                            </Typography>

                            <Box style={{display:'flex',flexDirection:'row',width:'100%',height:'50px',marginTop:'10px'}}>
                                <Typography style={{color:'#8892AE',fontSize:'14px',margin:'0px 5px 0px 0px',fontWeight:'300',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>{projectTech.one}</Typography>
                                <Typography style={{color:'#8892AE',fontSize:'14px',margin:'0px 5px 0px 5px',fontWeight:'300',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>{projectTech.two}</Typography>
                                <Typography style={{color:'#8892AE',fontSize:'14px',margin:'0px 5px 0px 5px',fontWeight:'300',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>{projectTech.three}</Typography>
                            </Box>


                        </CardContent>
                        </a>
                    </Card>
        </div>
    )
}

export default Project
